module.exports = __webpack_public_path__ + "static/img/81.1d8e746.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/81.png
// module id = HUST
// module chunks = 1